import { useQuery } from '@tanstack/react-query';
import { ListSystemsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { useMemo } from 'react';
import { useLoaderData } from 'react-router';
import { listSystemsQuery } from '~/shared/api/system.queries';
import { ListSystemsModel } from '~/shared/models/system/ListSystemsModel';
import { assertIsDefined } from '~/types/assert-type';

const useOptionalSystemsResponse = () => {
  const initialData = useLoaderData() as {
    systems: ListSystemsResponse;
  };

  return useQuery({
    ...listSystemsQuery,
    initialData: initialData?.systems,
  });
};

export const useRequiredSystems = () => {
  const { data: systems } = useOptionalSystemsResponse();

  assertIsDefined(systems);

  const listSystemsModel = useMemo(
    () => new ListSystemsModel(systems),
    [systems],
  );

  return listSystemsModel.systems;
};
